import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { StoreInformation } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/premium-stores')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: (
        <CrumbTitle
          title="Premium Stores"
          id="storeManagement.premiumStores.page.crumb.premiumStores"
          icon={StoreInformation}
        />
      ),
      title: <Translation id="storeManagement.premiumStores.page.title.premiumStores" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
